export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "index.worker.f4bda803c15bc6359d5f.worker.js");
}
